import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexPage from '../views/index.vue'
import WelcomePage from '../views/welcome.vue'
import FilesPage from '../views/files.vue'
import FavsPage from '../views/favs.vue'
import IngressPage from '../views/ingress.vue'
import IngressUploadPage from '../views/ingress-upload.vue'
import HistoryPage from '../views/history.vue'
import TasksPage from '../views/tasks.vue'
import SettingsPage from '../views/settings.vue'
import LandingPage from '../views/landing.vue'
import LoginPage from '../views/login.vue'
import RegisterPage from '../views/register.vue'
import PasswordsPage from '../views/passwords.vue'
import BuyPage from '../views/buy.vue'
import OrderPage from '../views/order.vue'
import OrderListPage from '../views/order-list.vue'
import NotesPage from '../views/notes.vue'
import PricingPage from '../views/pricing.vue'
import DocPage from '../views/doc.vue'
import store from '../store.js'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexPage
  },
  {
    path: '/landing',
    name: 'landing',
    component: LandingPage
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: WelcomePage,
  },
  {
    path: '/files',
    name: 'files',
    component: FilesPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
  },
  {
    path: '/favs',
    name: 'favs',
    component: FavsPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
  },
  {
    path: '/ingress',
    name: 'ingress',
    component: IngressPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
  },
  {
    path: '/i/:code',
    name: 'ingress-upload',
    component: IngressUploadPage,
  },
  {
    path: '/history',
    name: 'history',
    component: HistoryPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: TasksPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
  },
  {
    path: '/notes',
    name: 'notes',
    component: NotesPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
  },
  {
    path: '/passwords',
    name: 'passwords',
    component: PasswordsPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterPage,
    meta: {
      bg_class: 'bg-register',
    }
  },
  {
    path: '/activate',
    name: 'activate',
    component: () => import("@/views/activate"),
    meta: {
      bg_class: 'bg-register',
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      bg_class: 'bg-login',
    }
  },
  {
    path: '/buy',
    name: 'buy',
    component: BuyPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    }
  },
  {
    path: '/orders',
    name: 'orders',
    component: OrderListPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    }
  },
  {
    path: '/order',
    name: 'order',
    component: OrderPage,
    meta: {
      requiresAuth: true,
      sidebar: true,
    }
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: PricingPage,
    meta: {
      requiresAuth: false,
      sidebar: false,
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () =>
      import(
        "@/views/reset-password")
  },
  {
    path: '/download',
    name: 'download',
    component: () =>
      import(
        "@/views/download")
  },
  {
    path: '/help',
    name: 'help',
    component: () =>
      import(
        "@/views/help")
  },
  {
    path: '/doc/:id',
    name: 'doc',
    component: DocPage,
  },
  {
    path: '/404',
    alias: "*",
    name: '404',
    component: () =>
      import(
        /* webpackChunkName: "404" */
        "@/views/404")
  }
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.authenticated) {
      next({
        name: 'login',
        query: { redirect: to.fullPath }
      });
      return;
    }
  }
  next();
});

export default router
